import { createTheme } from "@mui/material";
import { Colors } from "../assets";
const theme = createTheme({
  palette: {
    primary: {
      main: Colors.primary,
    },
    secondary: {
      main: Colors.primary,
    },
    info: {
      main: Colors.primary,
    },
    success: {
      main: Colors.primary,
    },
    error: {
      main: "#E3597A",
    },
    warning: {
      main: "#F9F871",
    },
  },
});
export default theme;
